/* eslint-disable max-len */
import { get, xor } from 'lodash/fp';
import { ApplicationMarket, FinderVehicleCondition } from '../../../../../api/types';
import validators from '../../../../../utilities/validators';
import { newZealandMarketValidator, singaporeMarketValidator } from '../../shared/validators';

const validator = validators.compose(
    validators.requiredNonEmptyString('displayName'),
    validators.requiredString('identifier'),
    validators.requiredString('bankModuleId'),
    validators.requiredArray('vehicleModuleIds'),
    validators.requiredString('market'),
    validators.only(values => {
        const marketType = get('market', values);

        return marketType === ApplicationMarket.Singapore;
    }, singaporeMarketValidator),
    validators.only(values => {
        const marketType = get('market', values);

        return marketType === ApplicationMarket.NewZealand;
    }, newZealandMarketValidator)
);

export const updateValidator = (finderApplicationModuleConditions: FinderVehicleCondition[]) =>
    validators.compose(
        validators.requiredNonEmptyString('displayName'),
        validators.requiredString('identifier'),
        validators.requiredString('market'),
        validators.only(values => {
            const marketType = get('market', values);

            return marketType === ApplicationMarket.Singapore;
        }, singaporeMarketValidator),
        validators.only(values => {
            const marketType = get('market', values);

            return marketType === ApplicationMarket.NewZealand;
        }, newZealandMarketValidator),

        validators.only(
            values => {
                const defaultConditions = [
                    FinderVehicleCondition.New,
                    FinderVehicleCondition.Preowned,
                    FinderVehicleCondition.PorscheApproved,
                ];

                const differentSelection = xor(finderApplicationModuleConditions, defaultConditions);

                return differentSelection.length > 0;
            },
            validators.validFinderApplicationModuleCondition('finderModuleIds', finderApplicationModuleConditions, [
                FinderVehicleCondition.New,
                FinderVehicleCondition.Preowned,
            ])
        )
    );

export default validator;
